var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.106,
    height: 39.106,
    viewBox: "0 0 39.106 39.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4357",
    "data-name": "Group 4357",
    transform: "translate(-689.296 -6418.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M85.246,39.262H63.233a8.547,8.547,0,0,1-8.546-8.547V8.7A8.546,8.546,0,0,1,63.233.156H85.246A8.547,8.547,0,0,1,93.793,8.7V30.715a8.547,8.547,0,0,1-8.547,8.547",
    transform: "translate(634.609 6418.634)",
    fill: "#202131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M80.539,34.639H67.94a8.641,8.641,0,0,1-8.631-8.631v-12.6a8.641,8.641,0,0,1,8.631-8.63h12.6a8.641,8.641,0,0,1,8.631,8.63v12.6a8.641,8.641,0,0,1-8.631,8.631M67.94,7.782a5.633,5.633,0,0,0-5.626,5.626v12.6a5.633,5.633,0,0,0,5.626,5.626h12.6a5.633,5.633,0,0,0,5.627-5.626v-12.6a5.633,5.633,0,0,0-5.627-5.626Z",
    transform: "translate(634.609 6418.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M74.24,27.266A7.558,7.558,0,1,1,81.8,19.708a7.566,7.566,0,0,1-7.557,7.558m0-12.605a5.047,5.047,0,1,0,5.047,5.047,5.053,5.053,0,0,0-5.047-5.047",
    transform: "translate(634.609 6418.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M83.707,11.776a1.762,1.762,0,1,1-1.761-1.761,1.761,1.761,0,0,1,1.761,1.761",
    transform: "translate(634.609 6418.634)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.ef61e5a72c70ad1b32d873e014acd4b3.svg";
export { ForwardRef as ReactComponent };